<template lang="html">
  <div class="aMessage">
    <ShareHeader :openTarget="'messageBoard/detail?id=' + messageData.id" />

    <div class="postCon">
      <div class="singleTopicCon">
        <div class="userInformation">
          <p class="userHeader">
            <img :src="messageData.avatar" alt="" class="userImg">
            <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + messageData.uid" />
          </p>
          <p class="userText">
            <span class="userName">{{messageData.username}}</span>
            <span class="userTime">{{messageData.date}}</span>
          </p>
        </div>

        <div class="postSingleCon" :class="{allPost: cur}" v-html="messageData.message"></div>

        <div class="postMore" v-if="moreBtn" @click="postMore">
          查看更多
        </div>
      </div>
    </div>

    <!-- 评论 -->
    <div class="commentCon">
      <p class="commentAll">
        <span class="commentText">全部评论</span>
        <span class="commentLength">({{commentData.length}}条)</span>
      </p>
      <div class="commentList" v-for="(b, index) in commentData" :key="index">
        <img class="commentHeader" :src="b.avatar" alt="">
        <div class="commentAllCon">
          <div class="conLeft">
            <p class="commentTitle">{{b.username}}</p>
            <p class="commentContent">{{b.comment}}</p>
            <p class="commentReply">
              <span class="commentTime">{{b.createdate}}·</span>
              <span class="commentTimeText">回复Ta</span>
            </p>
            <p class="commentElse">
              <span>查看{{1}}条评论</span>
              <img src="../../assets/image/topic/right.png" alt="">
            </p>
          </div>
          <div class="commentCollection">
            <img src="../../assets/image/topic/collection.png" alt="">
            <span>{{b.like_number}}</span>
          </div>
        </div>
        <WxOpenTag ref="wxopentag" :extinfo="'messageBoard/detail?id=' + messageData.id" />
      </div>
    </div>

    <div class="callApp">
      打开APP查看更多
      <WxOpenTag ref="wxopentag" :extinfo="'messageBoard/detail?id=' + messageData.id" />
    </div>
  </div>
</template>

<script>
  import ShareHeader from '@/components/HeadModule'
  import WxOpenTag from '@/components/WxOpenTag'

  export default {
    data() {
      return {
        mid: this.$route.query.mid || '',
        messageData: [],
        commentData: [],
        cur: 0,
        moreBtn: 0,
      }
    },
    components: {
      ShareHeader,
      WxOpenTag,
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        document.title = '留言板';
        this.getData();
        this.getComment();
      },
      getData() {
        this.$http({
          url: '/eleom/messageDetail',
          method: 'get',
          params: {
            message_id: this.mid,
          },
        }).then(res => {
          if (res.code >= 0) {
            this.messageData = res.data;
            if (res.data.message.length > 100) {
              this.moreBtn = 1;
            }
          }
        })
      },
      getComment() {
        this.$http({
          url: '/eleom/messageCommentList',
          method: 'get',
          params: {
            message_id: this.mid,
            page: 1,
          },
        }).then(res => {
          if (res.code >= 0) {
            this.commentData = res.data;
          }
        })
      },

      // 按钮
      showCard() {
        this.cardShow = 1;
      },
      packUp() {
        this.cardShow = 0;
      },
      postMore() {
        this.moreBtn = 0;
        this.cur = 1;
        this.shadeShow = 1;
      },
      closeShade() {
        this.shadeShow = 0;
      }
    },
  }
</script>

<style lang="css" scoped>
  .aMessage {
    padding-bottom: 2rem;
  }

  /* 帖子 */
  .postCon {
    width: 100%;
    margin-top: .8rem;
    background-color: red;
  }

  .allTopicNum {
    height: 4.4rem;
    font-size: 1.4rem;
    color: #1D2023;
    box-sizing: border-box;
    padding: 1.2rem 1.5rem;
    background-color: #FFFFFF;
  }

  .singleTopicCon {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: 1.6rem 1.5rem;
    background-color: #FFFFFF;
  }

  .userInformation {
    display: flex;
    align-items: center;
  }

  .userHeader {
    position: relative;
  }

  .userHeader img {
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    margin-right: 1rem;
  }

  .userText {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .userName {
    font-size: 1.4rem;
    color: #1D2023;
  }

  .userTime {
    font-size: 1.2rem;
    color: #C0C4CC;
  }

  .postSingleCon {
    margin-top: 1.5rem;
    height: 10rem;
    overflow: hidden;
    word-break: break-all;
  }

  .allPost {
    overflow: auto;
    height: 100%;
  }

  .postMore {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 34.5rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    box-shadow: 0 -5px 3px -1px rgba(192, 196, 204, 0.8);
    font-size: 1.6rem;
    color: #F5A623;
    background-color: #FFFFFF;
  }

  /* 评论 */
  .commentCon {
    box-sizing: border-box;
    padding: 1.6rem 1.5rem;
    background-color: #FFFFFF;
  }

  .commentAll {
    border-top: .05rem solid #C0C4CC;
    padding-top: 1.6rem;
  }

  .commentText {
    font-size: 1.8rem;
    font-weight: 600;
    color: #1D2023;
  }

  .commentLength {
    margin-left: .6rem;
    font-size: 1.1rem;
    color: #606972;
  }

  .commentHeader {
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 1rem;
  }

  .commentList {
    position: relative;
    display: flex;
    padding-top: 1.6rem;
  }

  .commentAllCon {
    width: 100%;
    margin-left: 1rem;
    border-bottom: .05rem solid #E4E7ED;
    display: flex;
    justify-content: space-between;
    padding-bottom: 1.6rem;
  }

  .conLeft {}

  .commentTitle {
    font-size: 1.4rem;
    color: #9CA3A9;
  }

  .commentContent {
    word-break: break-all;
    font-size: 1.4rem;
    color: #1D2023;
    margin-top: .4rem;
  }

  .commentReply {
    margin-top: .6rem;
  }

  .commentTime {
    font-size: 1.2rem;
    color: #9CA3A9;
  }

  .commentTimeText {
    font-size: 1.2rem;
    color: #1D2023;
  }

  .commentElse {
    position: relative;
    font-size: 1.2rem;
    color: #808598;
    margin-top: 1.3rem;
  }

  .commentElse img {
    width: 1rem;
    margin-left: .3rem;
  }

  .commentCollection {
    margin-left: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.2rem;
    color: #606972;
  }

  .commentCollection img {
    width: 2rem;
    height: 2rem;
  }

  .callApp {
    position: relative;
    width: 34.5rem;
    height: 3.5rem;

    line-height: 3.5rem;
    text-align: center;
    color: #FFFFFF;
    background-color: #F7443F;
    margin: 0 auto;
  }
</style>